import 'es6-promise/auto';
import * as pb from './product_block';
import {responsiveImageTag} from './images';
import {Upsell} from './upsell';
import {ShopifyApi} from './api';
import {formatMoney} from '@shopify/theme-currency';
import { UpsellBundle } from './upsell_bundle';
import {SubscriptionQuantitySelector} from "./subscription_quantity_selector";
import {Emitter} from './emitter';
import * as bundleHelper from './helpers/bundle';

export const
    POPUP_STATE_IDLE = 'idle',
    POPUP_STATE_LOADING = 'loading',
    POPUP_STATE_READY = 'ready',
    POPUP_STATE_SUBMITTING = 'submitting',
    POPUP_STATE_ERROR = 'error',
    POPUP_STATE_COMPLETE = 'complete';


const IMAGE_PRELOAD_TIMEOUT_MSEC = 2e3,
    POPUP_IMAGE_SPEC = {maxWidth: 500};
const SRC_SET_FEATURED_IMAGES = ABV4_SETTINGS.src_set.popup_featured_images,
    SRC_SET_THUMBNAIL_IMAGES = ABV4_SETTINGS.src_set.popup_thumbnail_images;

const BASE_URL_IMAGE = ABV4_SETTINGS.base_url_image,
    IMAGE_VERSION = ABV4_SETTINGS.images_version;

const SUBSCRIPTION_ENABLED = ABV4_SETTINGS.bundle.subscription,
    BUNDLE_UPSELL = ABV4_SETTINGS.bundle.upsell_bundle;

export class AddToCartPopup extends Emitter {
    constructor(loader, cart, container) {
        super();
        this.loader = loader;
        this.cart = cart;
        this.api = new ShopifyApi;
        this.container = container;
        this.state = POPUP_STATE_IDLE;
        this.visible = false;
        this.forms = [];
        this.subscriptions = [];
        this.bundle = null;
        this.subscriptionQty = [];
        this.currencySymbol = currencySymbol;
        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleBlockLoading = this.handleBlockLoading.bind(this);
        this.handleBlockLoaded = this.handleBlockLoaded.bind(this);
        this.handleBlockLoadFailed = this.handleBlockLoadFailed.bind(this);
        this.handleVariantSelected = this.handleVariantSelected.bind(this);
        this.handleFormSubmitting = this.handleFormSubmitting.bind(this);
        this.handleFormSubmitted = this.handleFormSubmitted.bind(this);
        this.handleFormSubmitFailed = this.handleFormSubmitFailed.bind(this);
        this.handleBundleSubmitted = this.handleBundleSubmitted.bind(this);
        this.populateBundle = this.populateBundle.bind(this);
        this.newBundlePrice = this.newBundlePrice.bind(this);
        const
            popup = container.find('.v4-add-to-cart-popup'),
            blockContainer = popup.find('.v4-product-block'),
            block = new pb.ProductBlock(loader, cart, blockContainer, {imageSpec: POPUP_IMAGE_SPEC})
                .on('variantselected', this.handleVariantSelected)
                .on('loading', this.handleBlockLoading)
                .on('loaded', this.handleBlockLoaded)
                .on('loadfailed', this.handleBlockLoadFailed);

        this.attachForm(block.form);
        container.on('click', this.handleCloseClick);
        this.popup = popup;
        this.productBlock = block;
        this.statusMessage = popup.find('.status-message');
    }

    singleProductToBundleProduct(discount) {
        this.productBlock.singleProductToBundle(discount);
    }

    attachForm(form) {
        form.on('submitting', this.handleFormSubmitting)
            .on('submitted', this.handleFormSubmitted)
            .on('submitfailed', this.handleFormSubmitFailed);

        this.forms.push(form);
    }

    handleBlockLoading(e) {
        this.setStatusMessage('Loading product information');
        this.setState(POPUP_STATE_LOADING);
    }

    handleBlockLoaded(e) {
        const {product} = e.target;
        this.populate(product).then(() => {
            this.setState(POPUP_STATE_READY);
        });
    }

    handleBlockLoadFailed(e) {
        this.setStatusMessage('Oops, we couldn\'t load that product. Please try again or contact us if this problem persists.');
        this.setState(POPUP_STATE_ERROR);
    }

    handleFormSubmitting(e) {
        this.setStatusMessage('One moment...');

        this.setState(POPUP_STATE_SUBMITTING);

        this.show();
    }

    handleFormSubmitFailed(e) {
        this.setStatusMessage('Oops, something went wrong. Please try again or contact us if the problem persists.');
        this.setState(POPUP_STATE_ERROR);
    }

    handleBundleSubmitted(bundleData, mode = null, skiptocart) {
        let message = `<strong class="product-title">1 &times; ${bundleData.bundle_name}</strong> has been added to your cart.`;
        this.cart.count().then((data) => {
            $('.v5-cart-item-count').css('display', 'block');
            $('.v5-cart-item-count').text(data); 
        });
        if(skiptocart) {
            window.location.href = '/cart';
            return;
        }
        
        if(mode !== 'upsell' && typeof bundle_upsell[bundleData.bundle_class] !== 'undefined' && BUNDLE_UPSELL) {
            new UpsellBundle(bundleData, this.api, this.cart, this);
        }

        this.cart.operation = null;
        this.cart.getData()
            .then((data) => {
                this.cart.itemCountUpdate(data);
                $('.mini-cart-wrapper').addClass('active');
                $('.mini-cart-popup').addClass('active');
                $('html').addClass('mini-cart-opened');
                this.hide();
                let currentTimestamp = new Date();
                currentTimestamp = currentTimestamp.getTime();
                const miniCartClass = `mini-cart-message-${currentTimestamp}`
                $('#mini-cart-massages').append(`<p class="mini-cart-info mini-cart-info__added ${miniCartClass}">${bundleData.bundle_name} added to cart.</p>`);
                $('#mini-cart-massages').removeClass('d-none');
                setTimeout(() => {
                    $('#mini-cart-massages').find(`.${miniCartClass}`).remove();
                }, "3000");
                return;
                message += `<span class="cart-total"><span class="label">Cart Total: </span>${cartTotal}`;
                this.setStatusMessage(message);
                if(typeof bundle_upsell[bundleData.bundle_class] !== 'undefined')
                    $('.v5-bundle-upsell-wrapper').removeClass('d-none');
                this.setState(POPUP_STATE_COMPLETE);
                this.popup.find('.subscription-consent').data('subscription-consent', false);
                this.popup.find('.subscription-consent').attr('data-subscription-consent', false);

            })
            .catch((e) => {
                this.setStatusMessage(message);
                this.setState(POPUP_STATE_COMPLETE);
            });
    }

    handleFormSubmitted(e) {
        const
            form = e.target, { product, formData } = form,
            quantity = form.getFormData('quantity'),
            addedFrom = form.form.parent().parent().hasClass('product-pane');
        let message = `<strong class="product-title">${quantity} &times; ${product.title()}</strong> has been added to your cart.`;
        if(formData.hasOwnProperty('gift_product_count')) {
            message = `<strong class="product-title">${quantity} &times; ${product.title()}</strong> and a free gift has been added to your cart.`;
        }
        this.cart.operation = null;
        this.cart.getData()
            .then((data) => {
                this.cart.itemCountUpdate(data);
                $('.mini-cart-wrapper').addClass('active');
                $('.mini-cart-popup').addClass('active');
                $('html').addClass('mini-cart-opened');
                this.hide();
                let currentTimestamp = new Date();
                currentTimestamp = currentTimestamp.getTime();
                const miniCartClass = `mini-cart-message-${currentTimestamp}`
                $('#mini-cart-massages').append(`<p class="mini-cart-info mini-cart-info__added ${miniCartClass}">${product.title()} added to cart.</p>`);
                $('#mini-cart-massages').removeClass('d-none');
                setTimeout(() => {
                    $('#mini-cart-massages').find(`.${miniCartClass}`).remove();
                }, "3000");
                return;
                if (!form.formData.hasOwnProperty('subsave')) {
                    new Upsell(this.cart, this.api, '.v5-upsell-placeholder-collection', 'select_option', 'popup', true, addedFrom);
                }
                message += `<span class="cart-total"><span class="label">Cart Total: </span>${cartTotal}`;

                // this.setStatusMessage(message);
                // this.setState(POPUP_STATE_COMPLETE);
            })
            .catch((e) => {
                this.setStatusMessage(message);
                this.setState(POPUP_STATE_COMPLETE);
            });
    }

    // check if bundle contain subscription product
    setProductHandle(handle, bundleDiscount, frequency = null) {
        this.container.find('.v4-add-to-cart-popup').attr('data-popup-product-handle', handle);
        return this.productBlock.loadFromHandle(handle, bundleDiscount, frequency);
    }

    bundleContainsSubscriptionProducts(bundle) {
        const matchedProductsId = [];
        for (const item of bundle.bundle_components) {
            for (const subItem of subscribtion_products) {
                if (item.id === subItem.variant_id && SUBSCRIPTION_ENABLED) {
                    this.subscriptionQty[item.id] = item.qty ? item.qty : 1;
                    matchedProductsId.push(subItem);
                }
            }
        }

        return matchedProductsId;
    }

    setState(newState) {
        this.popup
            .toggleClass('ready', newState === POPUP_STATE_READY)
            .toggleClass('loading', newState === POPUP_STATE_LOADING)
            .toggleClass('submitting', newState === POPUP_STATE_SUBMITTING)
            .toggleClass('error', newState === POPUP_STATE_ERROR)
            .toggleClass('complete', newState === POPUP_STATE_COMPLETE);
        this.state = newState;
    }

    setStatusMessage(message) {
        this.statusMessage.html(message);
    }

    handleCloseClick(e) {
        const target = $(e.target);
        if (target.is('.close-button, .continue-shopping, .v4-add-to-cart-popup-container')) {
            // $('.v4-add-to-cart-popup').find('.v5-upsell-quick-add-to-cart').html('');
            $('.v4-add-to-cart-form').find('#bundled_products').html(``);
            $('.v4-add-to-cart-form').find('.variant-select').attr('name', 'id');

            this.hide();
            e.preventDefault();
            e.stopPropagation();
        }
    }

    handleVariantSelected(e, product, variantIndex) {
        const images = product.getImages(variantIndex || 0);
        const { popup } = this, featured = product.featuredImage(variantIndex);
        popup.toggleClass('has-image', featured !== null);
        const imageFrame = popup.find('.carousel-inner'),
            currsorsFrame = popup.find('.carousel-indicators');
        let saving = product.formatSaving(variantIndex),
        frameHtml = '';
        const imageFrameWrapper = popup.find('.product-pane .image-frame-wrapper');
        saving = saving !== null ? `<div class="saving">${saving}</div>` : '';
        if(this.getCookie('localization') != "US"){
            saving = '';
        }
        popup.addClass('has-image');
        let currsors = '';
        for (let i = 0; i < images.length; i++) {
            const image = images[i]
            const img = responsiveImageTag(image, SRC_SET_FEATURED_IMAGES);
            const isActive  =  i == 0 ? 'active' : '';
            frameHtml += `<div class="carousel-item ${isActive}">
            <div class="carousel-inner-div">${img}</div>
          </div>`;
          currsors += `<div class="carousel-indicator ${isActive}" data-target="#carouselExampleIndicators" data-slide-to="${i}">
          ${img}
          </div>`;
        }
        imageFrameWrapper.find('.saving').remove();
        imageFrameWrapper.prepend(saving);
        imageFrame.html(frameHtml);
        if(images.length > 1 ) {
            currsorsFrame.html(currsors);

        } else {
            currsorsFrame.html(' ');
        }
    }

    populate(product) {
        const image = this.popup.find('.image-frame img');
        if (image.length === 0)
            return Promise.resolve();

        return new Promise((resolve) => {
            if (image[0].complete) {
                resolve();
            } else {
                image.one('load', resolve);
                setTimeout(resolve, IMAGE_PRELOAD_TIMEOUT_MSEC);
            }
        });
    }

    show() {
        if (!this.visible) {
            $('html').addClass('v4-add-to-cart-popup__opened')
            this.container.addClass('visible');
            this.visible = true;
        }
    }

    hide() {
        if (this.visible) {
            $('html').removeClass('v4-add-to-cart-popup__opened')
            this.container.removeClass('visible');
            this.visible = false;
        }
    }

    setBundleHandle(handle, bundle, bundleLabel, subscribe, clonedDesc, skiptocart, ctalabel, gallery, frequency) {
        this.setStatusMessage('Loading bundle information...');
        this.setState(POPUP_STATE_LOADING);
        this.show();
        this.subscriptions = [];
        this.populateBundle(bundle, bundleLabel, subscribe, clonedDesc, ctalabel, gallery, frequency).then(() => {
            this.setState(POPUP_STATE_READY);
        });
    }

    populateSubscription(subProducts, productsQty) {
        let htmlFrame = '';
        for (const item of subProducts) {
            htmlFrame += `<div class="single-subscription" data-variant-id="${item.variant_id}" data-product-handle="${item.handle}">
                            <h5><span class="rc-product-name">${item.name}</span> <span class="rc-discount">${item.recharge_discount}%</span><span class="rc-discounted-price">${item.rc_price}</span></h5>
                            <div class="subscription-qty-selector" data-base-product-qty="${productsQty[item.variant_id]}">  
                                <button type="button" class="step-button down">-</button>
                                <input type="number" name="quantity" value="${productsQty[item.variant_id]}" min="${productsQty[item.variant_id]}" max="10">
                                <button type="button" class="step-button up">+</button>
                            </div>
                        </div>`;
        }

        return htmlFrame;
    }


    populateBundle(bundle, bundleLabel, subscribe, clonedDesc, ctalabe, gallery, frequency) {
        this.bundle = bundle;
        let bundleDesc = typeof bundle_description[bundle.bundle_class] != 'undefined' ? bundle_description[bundle.bundle_class] : '';
        const prices = bundleHelper.getBundlePrice(bundle),
            bundleBlock = this.popup.find('.v5-bundle-block');
        const subProducts = this.bundleContainsSubscriptionProducts(bundle);
        this.popup.addClass('has-image');
        this.populateBundleImage(bundle, bundleLabel, gallery);
        this.populateProductsName(bundle);
        if(typeof clonedDesc != 'undefined') {
            bundleDesc = clonedDesc;
        }
        bundleBlock.find('.bundle-description').html(bundleDesc);
        if(bundle.bundle_discount === 0 || this.getCookie('localization') != "US"){
            bundleBlock.find('.header .pricing').addClass('d-none');   
        } else {
            bundleBlock.find('.header .pricing').removeClass('d-none');      
        }
        if (subProducts.length > 0 && subscribe) {
            bundleBlock.find('.subscription-wrapper').removeClass('d-none');
            const subHtml = this.populateSubscription(subProducts, this.subscriptionQty);
            bundleBlock.find('.subscription-option-wrapper').html(subHtml);
            bundleBlock.find('.subscription-qty-selector').each((e, value) => {
                new SubscriptionQuantitySelector($(value)).on('subqtychange', this.newBundlePrice);
            });

            bundleBlock.find('.subscription-option-wrapper').addClass('d-none');
            bundleBlock.find('.subscription-frequency').addClass('d-none');
            bundleBlock.find('.subscription-consent').data('subscription-consent', false);
            bundleBlock.find('.subscription-consent #not_subscribe').prop('checked', true);
            bundleBlock.find('.subscription-consent input[type="radio"]').on('change', (e) => {
                const consent = bundleBlock.find('.subscription-consent'),
                    subscribe = $(e.currentTarget).val();
                if (subscribe === 'true') {
                    if(frequency !== null) {
                        const spOptionContainer = bundleBlock.find('.subscription-frequency select');
                        let frequencyArr = [frequency];
                        if(typeof frequency !== 'number') {
                            frequencyArr = frequency.split(',');
                        }
                        this.showSpecificFrequency(frequencyArr, spOptionContainer);
                    }
                    bundleBlock.find('.subscription-option-wrapper').removeClass('d-none');
                    bundleBlock.find('.subscription-frequency').removeClass('d-none');
                } else {
                    this.newBundlePrice(e, null, null);
                    bundleBlock.find('.subscription-option-wrapper').addClass('d-none');
                    bundleBlock.find('.subscription-frequency').addClass('d-none');
                    this.resetInputs();
                }
                consent.attr('data-subscription-consent', subscribe);
            });
        } else {
            bundleBlock.find('.subscription-consent').attr('data-subscription-consent', false);
            bundleBlock.find('.subscription-wrapper').addClass('d-none');
        }

        bundleBlock.find('.title').text(bundle.bundle_name);
        bundleBlock.find('.comparison-price').text(prices[1]);
        bundleBlock.find('.pricing .price').text(prices[0]);
        if(this.getCookie('localization') != 'US') {
            bundleBlock.find('.comparison-price').text(' ');
            bundleBlock.find('.pricing .price').text(prices[1]);   
        }
 
        
        let htmlCtaLabel = 'Add To Cart';
        if(typeof ctalabel === 'string') {
            htmlCtaLabel = ctalabel;
        }
        let atcPrice = prices[0];
        if(this.getCookie('localization') != 'US') {
            atcPrice = prices[1];
        }
        let htmlatc =
            `<span class="caption">${htmlCtaLabel}</span>
            <span class="separator">|</span>
            <span class="price">${atcPrice}</span>`;
        bundleBlock.find('.add-bundle-to-cart').html(htmlatc);
        bundleBlock.find('.add-bundle-to-cart').attr('data-bundle', bundle.bundle_class);

        return Promise.resolve();
    }
    getCookie(name) {
        var pattern = RegExp(name + "=.[^;]*")
        var matched = document.cookie.match(pattern)
        if(matched){
            var cookie = matched[0].split('=')
            return cookie[1]
        }
        return null;
    }

    showSpecificFrequency(frequencyArr, selectOptions) {
        const validOptions = [];
        let firstFinded = true;
            for (let i = 0; i < selectOptions.find('option').length; i++) {
                let isIncluded = false;
                const option = selectOptions.find('option')[i];
                for(const [index,item] of frequencyArr.entries()) {
                    if ($(option).text().includes(item)) {
                        isIncluded = true;
                    }
                }
                if(isIncluded && firstFinded) {
                    firstFinded = false;
                    $(option).prop('selected', 'selected');
                    $(selectOptions).val($(option).val());
                } else if(isIncluded === false) {
                    $(option).addClass('d-none');
                } else if(isIncluded) {
                    $(option).removeClass('d-none');
                } else {}
            }
    }

    resetInputs() {
        const {bundle} = this, components = bundle.bundle_components, inputs = $('.single-subscription');
        for (const input of inputs) {
            let defaultQuantity = 1;
            const variantId = $(input).data('variant-id');
            for (const component of components) {
                if (component.hasOwnProperty('qty')) {
                    if (variantId === component.id) {
                        defaultQuantity = component.qty;
                    }
                }
            }
            $(input).find('[type="number"]').val(defaultQuantity);
        }
    }

    populateProductsName(bundle) {
        const components = bundle.bundle_components,
            {popup} = this, bundleBlock = popup.find('.v5-bundle-block');
        let html = '';
        for (const component of components) {
            if (!component.hasOwnProperty('name'))
                break;

            const qty = component.qty ? component.qty : 1,
                name = component.name;
            html += `<div class="single-product-wrapper">
                        <div class="qty">${qty}x </div>
                        <div class="name">${name}</div>
                    </div>`
        }

        bundleBlock.find('.bundle-includes-wrapper .bundle-includes').html(html);
    }

    newBundlePrice(e, inputValue, variantId) {
        const {bundle, popup, subscriptionQty} = this,
            bundleBlock = popup.find('.v5-bundle-block');
        let discountedPrice = 0;
        let originalPrice = 0;
        if (inputValue === null && variantId === null)
            this.subscriptionQty = [];

        for (const product of bundle.bundle_components) {
            let quantity = product.qty;
            if (product.id === variantId) {
                subscriptionQty[product.id] = inputValue;
            }
            if (subscriptionQty.hasOwnProperty(product.id) && variantId !== null)
                quantity = subscriptionQty[product.id];
            let discount = bundle.bundle_discount;
            if(product.hasOwnProperty('discount')){
                discount = product.discount;
            }
            
            const discountedAmount = 1 - (discount * 0.01);
            let qty = quantity ? quantity : 1,
                price = product.price * qty,
                discountMath = price * discountedAmount;
            discountedPrice += discountMath;
            originalPrice += price;
        }

        bundleBlock.find('.comparison-price').text(formatMoney(originalPrice * 100, window.moneyFormat));
        bundleBlock.find('.price').text(formatMoney(discountedPrice * 100, window.moneyFormat));
    }


    populateBundleImage(bundle, bundleLabel, gallery) {
        const discount = bundle.bundle_discount;
        const { popup } = this;
        let ribbon = '';
        if(bundle.bundle_discount % 1 === 0) {
            ribbon = `<div class="saving">Save ${discount}%</div>`;
        } else {
            ribbon = `<div class="saving">Save over ${Math.floor(discount)}%</div>`;
        }
        if(typeof bundleLabel !== 'undefined') {
            ribbon = `<div class="saving">${bundleLabel}</div>`;
        }
        if(bundle.bundle_discount === 0 || this.getCookie('localization') != "US"){
            ribbon = '';
        }
       let url = BASE_URL_IMAGE + `cart_bundle_` + bundle.bundle_class + `.jpg?v=`+ IMAGE_VERSION;
       let imageobj = {url:url, alt: bundle.bundle_name};
        const image = `
        ${ribbon}
        ${responsiveImageTag(imageobj, SRC_SET_FEATURED_IMAGES)};`;
        const imageFrameWrapper = popup.find('.bundle-pane .image-frame-wrapper');
        const imageFrame = popup.find('.bundle-pane .carousel-inner'),
            currsorsFrame = popup.find('.bundle-pane .carousel-indicators');
            currsorsFrame.html(' ');
        let frameHtml = '';
        popup.addClass('has-image');

        if(gallery == null) gallery = 1;
        let currsors = '';
        for (let i = 0; i < gallery; i++) {
            let url = '';
            if(i === 0){
                url = BASE_URL_IMAGE + `cart_bundle_` + bundle.bundle_class + `.jpg?v=`+ IMAGE_VERSION;
            } else {
                url = BASE_URL_IMAGE + `popup_img_${i}_cart_bundle_` + bundle.bundle_class + `.jpg?v=`+ IMAGE_VERSION;
            }
            let imageobj = {url:url, alt: bundle.bundle_name};
            const img = responsiveImageTag(imageobj, SRC_SET_FEATURED_IMAGES);
            const isActive  =  i == 0 ? 'active' : '';
            frameHtml += `<div class="carousel-item ${isActive}">
            <div class="carousel-inner-div">${img}</div>
          </div>`;
          currsors += `<div class="carousel-indicator ${isActive}" data-target="#carouselExampleIndicators1" data-slide-to="${i}">
          ${img}
          </div>`;
        }
        imageFrameWrapper.find('.saving').remove();
        imageFrameWrapper.prepend(ribbon);
        imageFrame.html(frameHtml);
        if(gallery > 1) {
            currsorsFrame.html(currsors);
        }
    }

    subscriptionProducts() {
        this.subscriptions = [];
        const bundleBlock = this.popup.find('.v5-bundle-block');
        
        bundleBlock.find('.single-subscription').each((e, value) => {
            const variantId = $(value).data('variant-id'),
                subscribed = bundleBlock.find('.subscription-consent').attr('data-subscription-consent'),
                handle = $(value).data('product-handle'),
                quantity = $(value).find('input[name="quantity"]').val(),
                frequency = bundleBlock.find('select.frequency').val(),
                obj = {
                    variant_id: variantId,
                    subscribed: subscribed,
                    quantity: quantity,
                    frequency: frequency,
                    handle: handle
                };

            this.subscriptions.push(obj);
        });

        return this.subscriptions;
    }

}
